import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { Link } from 'react-router-dom';
import format from 'date-fns/format';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint, faPaperclip, faFile, faTimes } from '@fortawesome/free-solid-svg-icons';

import {
	APPEAL_NEW,
	APPEAL_REGISTERED,
	APPEAL_ADDITIONAL,
	APPEAL_COMPETENCE,
	APPEAL_RESOLVED
} from '../../../site/pages/reception/statuses';
import { Button, Popconfirm, Select, DatePicker, FileInput } from '@smartplatform/ui';
import store from '../../store';
import './style.scss';
import ReactToPrint from 'react-to-print';
import { AppealPrintVersion } from './AppealPrintVersion'
@observer
export default class Edit extends React.Component {
	
	@observable record = null;
	@observable error = null;
	@observable statuses = [];
	@observable logs = [];
	@observable status = null;
	@observable statusText = '';
	@observable statusDate = null;
	@observable statusFile = null;
	@observable isSaving = false;
	@observable statusError = null;

	constructor(props) {
		super(props);
		this.init();
	}
	
	init = async () => {
		await this.loadStatuses();
		await this.loadRecord();
		await this.loadLogs();
	};
	
	loadRecord = async () => {
		this.id = this.props.match.params.id;
		this.error = null;
		
		if (this.id) {
			try {
				this.record = await store.model.Appeal.findById(this.id, { include: ['deputy','status'] });
			}
			catch(e) {
				this.error = e.message;
			}
		}
		else {
			this.record = new store.model.Appeal();
		}
	};
	
	loadLogs = async () => {
		this.logs = await store.model.AppealLog.find({
			where: {
				appealId: this.record.id,
			},
			include: ['status'],
			order: 'id asc',
		})
	};
	
	loadStatuses = async () => {
		this.statuses = await store.model.AppealStatus.find({
			order: 'id asc',
		});
	};
	
	fio = record => record && <>
		{record.lastName } {record.firstName || ''} {record.middleName || ''}
	</>;
	
	delete = async record => {
		console.log('delete', record);
		await record.delete();
		this.props.history.push('/admin/appeals');
	};
	
	onStatusSelect = status => {
		console.log('onStatusSelect', status);
		this.status = status;
		this.statusDate = new Date();
	};
	
	onStatusTextChange = e => {
		this.statusText = e.target.value;
	};
	
	onStatusDateChange = date => {
		console.log('onStatusDateChange', date);
		this.statusDate = date;
	};
	
	onStatusFileChange = e => {
		this.statusFile = e.target.files[0];
		console.log('onStatusFileChange', this.statusFile);
	};
	
	deleteFile = () => this.statusFile = null;
	
	submitStatus = async () => {
		this.statusError = null;
		
		const { textLabel, dateLabel } = this.getLabels(this.status.id);
		if (this.status.id > APPEAL_NEW && this.status.id < APPEAL_RESOLVED && this.statusText.trim().length === 0) {
			this.statusError = `Заполните поле "${textLabel}"`;
			return;
		}
		if (!this.statusDate) {
			this.statusError = `Заполните поле "${dateLabel}"`;
			return;
		}
		
		this.isSaving = true;
		const appealLog = new store.model.AppealLog();
		appealLog.appeal = this.record;
		appealLog.status = this.status;
		appealLog.text = this.statusText;
		appealLog.date = this.statusDate;
		await appealLog.save();

		if (this.statusFile) {
			await appealLog.uploadFile('file', this.statusFile);
			appealLog.file = this.statusFile.name;
			await appealLog.save();
		}
		
		if (this.status.id === APPEAL_REGISTERED) {
			this.record.regNum = this.statusText;
		}
		
		this.record.status = this.status;
		await this.record.save();

		this.isSaving = false;
		this.resetStatus();
		// this.loadRecord();
		this.loadLogs();
	};
	
	cancelStatusChange = () => {
		this.resetStatus();
	};
	
	resetStatus = () => {
		this.status = null;
		this.statusText = '';
		this.statusDate = null;
		this.statusFile = null;
	};
	
	getLabels = statusId => {
		let textLabel = 'Текст';
		let dateLabel = 'Дата';
		if (statusId === APPEAL_REGISTERED) {
			textLabel = 'Регистрационный номер';
			dateLabel = 'Дата регистрации';
		}
		else if (statusId === APPEAL_ADDITIONAL) {
			textLabel = 'Наименование органа, которому отправлен запрос';
			dateLabel = 'Дата запроса';
		}
		else if (statusId === APPEAL_COMPETENCE) {
			textLabel = 'Наименование органа, которому отправлено обращение';
			dateLabel = 'Дата направления';
		}
		else if (statusId === APPEAL_RESOLVED) {
			textLabel = 'Комментарий';
			dateLabel = 'Дата ответа';
		}
		return { textLabel, dateLabel };
	};
	
	render() {
		if (!this.record && !this.error) return '...';
		if (this.error) return this.error;
		
		const items = this.statuses.map(status => {
			let disabled = false;
			if (status.id === APPEAL_NEW) disabled = true;
			if (this.record.statusId === APPEAL_NEW && status.id !== APPEAL_REGISTERED) disabled = true;
			if (this.record.statusId >= APPEAL_REGISTERED && status.id <= APPEAL_REGISTERED) disabled = true;
			return { value: status, label: status.name, disabled }
		});
		
		let textLabel = '';
		let dateLabel = '';
		if (this.status) {
			const labels = this.getLabels(this.status.id);
			textLabel = labels.textLabel;
			dateLabel = labels.dateLabel;
		}
		
		return <div className="appeal-edit">
			<p>Обращение <strong>№ {this.record.id}</strong></p>
			<div>
				Депутат: <Link to={`/admin/deputies/${this.record.deputyId}`}><strong>{this.fio(this.record.deputy)}</strong></Link>
			</div>
			<div>
				Создано: <strong>{this.record.createdAt ? format(new Date(this.record.createdAt), 'dd.MM.yyyy HH:mm') : '-'}</strong>
			</div>
			<div><br /></div>
			<div>
				Отправитель: <strong>{this.fio(this.record)}</strong>
			</div>
			<div>
				Контактный телефон: <strong>{this.record.phone || '-'}</strong>
			</div>
			<div>
				Адрес места жительства: <strong>{this.record.address || '-'}</strong>
			</div>
			<div>
				E-mail: {this.record.email && <a href={`mailto:${this.record.email}`}><strong>{this.record.email}</strong></a>}
			</div>
			<div>
				Текст обращения: <strong>{this.record.text || '-'}</strong>
			</div>
			<div>
				Файл: {this.record.attachment ? <a target="_blank" href={this.record.downloadFile('attachment')}>{this.record.attachment}</a> : '-'}
			</div>
			<div><br /></div>
			<div>
				Статус: <strong>{this.record.status ? this.record.status.name : '-'}</strong>
			</div>
			{this.logs.length > 0 && <div className="appeal-logs">
				{this.logs.map(log => {
					const { textLabel, dateLabel } = this.getLabels(log.statusId);
					return <div key={log.id} className="appeal-log">
						<div className="status">
							Статус: <em>{log.status ? log.status.name : '-'}</em>
						</div>
						<div className="date">
							{dateLabel}: <em>{log.date ? format(new Date(log.date), 'dd.MM.yyyy HH:mm') : '-'}</em>
						</div>
						<div className="text">
							{textLabel}: <em>{log.text || '-'}</em>
						</div>
						{log.file && <div className="file">
							Файл: <em><a target="_blank" href={log.downloadFile('file')}>{log.file}</a></em>
						</div>}
					</div>;
				})}
			</div>}
			<div><br /></div>
			{this.record.id && <div className="row">
				<div className="form-field col-12 col-sm-3 col-md-3 col-lg-3">
					<label>Изменить статус</label>
					<Select
						items={items}
						className="drop-down-md"
						value={this.status}
						onChange={this.onStatusSelect}
						isRequired={true}
						noSearch={true}
						disabled={this.record.statusId === APPEAL_RESOLVED || this.isSaving}
					/>
				</div>
			</div>}
			{this.status && <>
				<div className="row">
					<div className="form-field col-12 col-sm-3 col-md-3 col-lg-3">
						<label>{textLabel}</label>
						<input type="text" value={this.statusText} onChange={this.onStatusTextChange} disabled={this.isSaving} />
					</div>
					<div className="form-field col-12 col-sm-3 col-md-3 col-lg-3">
						<label>{dateLabel}</label>
						<DatePicker
							value={this.statusDate}
							onChange={this.onStatusDateChange}
							showTimeSelect={true}
							disabled={this.isSaving}
							dateFormat="dd.MM.yyyy HH:mm"
						/>
					</div>
				</div>
				<div className="form-field">
					<label>Файл</label>
					<input type="file" id="attachment" onChange={this.onStatusFileChange} accept=".doc, .docx, .rtf, .pdf, .jpg, .png" disabled={this.isSaving} />
					<label htmlFor="attachment"><FontAwesomeIcon icon={faPaperclip} /> Прикрепить файл</label>
					{this.statusFile && <span className="file-info">
						<FontAwesomeIcon icon={faFile} />
						<span className="filename">{this.statusFile.name}</span>
						<span className="delete-btn" onClick={this.deleteFile}><FontAwesomeIcon icon={faTimes} /></span>
					</span>}
				</div>
				<div className="form-field">
					<label>&nbsp;</label>
					<Button className="btn-primary" onClick={this.submitStatus} disabled={this.isSaving}>Сохранить</Button> &nbsp;
					<Button onClick={this.cancelStatusChange} disabled={this.isSaving}>Отмена</Button> &nbsp;
					<span className="status-error">{this.statusError}</span>
				</div>
			</>}
			<div><br />
				<ReactToPrint
					trigger={() => <Button label="Распечатать"/> }
          content={() => this.componentRef}
        />
				<div style={{display: 'none'}}>
					<AppealPrintVersion ref={el => (this.componentRef = el)} record={this.record} fio={this.fio} />
				</div>
      </div>
			<div><br />
				<Popconfirm content="Удалить?" onConfirm={() => this.delete(this.record)}>
					<a href="#" onClick={e => e.preventDefault()}>Удалить</a>
				</Popconfirm>
			</div>
		</div>;
	}
	
}
